import { useState, useEffect, useRef, useCallback } from "react";
import storage, { COLLECTIONS } from "../storage";

// ─── FONTS ───────────────────────────────────────────────────────────────────
const BR_FONTS = `@import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Mono:wght@400;500&display=swap');`;

// ─── THEME ───────────────────────────────────────────────────────────────────
const TH = {
  bg:           "#eeeae3",
  surface:      "#faf9f6",
  surfaceWhite: "#ffffff",
  border:       "#d6d2ca",
  text:         "#0f2235",
  textSub:      "#374151",
  textMuted:    "#6b7280",
  accent:       "#1a5c3a",
  navy:         "#0f2235",
};

// ─── SHARED STYLES ────────────────────────────────────────────────────────────
const INPUT_STYLE = {
  width: "100%", background: TH.surfaceWhite, border: `1px solid ${TH.border}`,
  borderRadius: 6, padding: "0.65rem 0.9rem", color: TH.text,
  fontFamily: "'Syne',sans-serif", fontSize: "0.88rem", outline: "none",
  boxSizing: "border-box",
};
const TEXTAREA_STYLE = { ...INPUT_STYLE, resize: "vertical", minHeight: "5rem" };

// ─── I18N ────────────────────────────────────────────────────────────────────
const T = {
  es: {
    title:                   "Registro de Brechas GDPR",
    back:                    "Todas las herramientas",
    newBreach:               "Nueva brecha +",
    noBreach:                "No hay brechas registradas",
    noBreachSub:             "Registra tu primer incidente para hacer seguimiento de las obligaciones de notificación.",
    firstBreach:             "Registrar primera brecha →",
    formTitleNew:            "Nueva brecha",
    formTitleEdit:           "Editar brecha",
    save:                    "Guardar",
    cancel:                  "Cancelar",
    fieldCompany:            "Empresa",
    fieldIncidentDate:       "Fecha del incidente",
    fieldDetectionDate:      "Fecha de detección",
    fieldDescription:        "Descripción del incidente",
    fieldDataCats:           "Categorías de datos afectados",
    fieldAffectedSubjects:   "Afectados estimados",
    fieldAffectedCountries:  "Países afectados (separados por coma)",
    fieldIncidentType:       "Tipo de incidente",
    fieldCause:              "Causa",
    fieldLikelihood:         "Probabilidad de daño a los interesados",
    fieldSeverity:           "Gravedad del daño potencial",
    fieldContainment:        "Medidas de contención aplicadas",
    fieldStatus:             "Estado del incidente",
    fieldNotif72hSentAt:     "Fecha de notificación a la autoridad (Art. 33)",
    fieldNotif72hNotes:      "Notas — notificación a autoridad",
    fieldNotifSubjectsSentAt:"Fecha de comunicación a interesados (Art. 34)",
    fieldNotifSubjectsNotes: "Notas — comunicación a interesados",
    typeConfidentiality:     "Confidencialidad",
    typeIntegrity:           "Integridad",
    typeAvailability:        "Disponibilidad",
    typeMultiple:            "Múltiple",
    low:                     "Bajo",
    medium:                  "Medio",
    high:                    "Alto",
    statusOpen:              "Abierto",
    statusInvestigating:     "Investigando",
    statusContained:         "Contenido",
    statusClosed:            "Cerrado",
    colCompany:              "Empresa",
    colDate:                 "Fecha incidente",
    colType:                 "Tipo",
    colStatus:               "Estado",
    colNotif72h:             "Notif. 72h",
    btnView:                 "Ver",
    btnEdit:                 "Editar",
    btnDelete:               "Eliminar",
    btnExport:               "Exportar",
    btnImport:               "Importar JSON",
    detailTitle:             "Detalle de brecha",
    backToList:              "← Volver a lista",
    notifSection:            "Evaluación de notificabilidad",
    notif72hTitle:           "Notificación a la autoridad de control",
    notifSubjectsTitle:      "Comunicación a los interesados",
    required:                "REQUERIDA",
    notRequired:             "NO REQUERIDA",
    art33:                   "Art. 33 RGPD",
    art34:                   "Art. 34 RGPD",
    deadline72h:             "Plazo límite (72h desde detección):",
    notSent:                 "No registrada",
    criteriaLikelihood:      "Probabilidad de daño no es baja",
    criteriaSeverity:        "Gravedad del daño no es baja",
    criteriaSensitiveData:   "Contiene categorías de datos sensibles",
    criteriaHighRisk:        "Alta probabilidad y alta gravedad",
    validationRequired:      "Nombre del incidente, empresa, fecha de incidente, fecha de detección y descripción son obligatorios.",
    confirmDelete:           "¿Eliminar esta brecha? Esta acción no se puede deshacer.",
    importError:             "Error al importar: el archivo no tiene el formato esperado o no pertenece a esta colección.",
    saveNotif:               "Guardar notas de notificación",
    notifSavedOk:            "Guardado.",
    notifInfoTitle:          "Registro de notificaciones enviadas",
    incidentInfo:            "Datos del incidente",
    riskInfo:                "Evaluación de riesgo",
    responseInfo:            "Respuesta al incidente",
    labelCompany:            "Empresa",
    labelIncidentDate:       "Fecha del incidente",
    labelDetectionDate:      "Fecha de detección",
    labelDescription:        "Descripción",
    labelCause:              "Causa",
    labelIncidentType:       "Tipo de incidente",
    labelDataCats:           "Categorías de datos",
    labelAffectedSubjects:   "Afectados estimados",
    labelAffectedCountries:  "Países afectados",
    labelLikelihood:         "Probabilidad de daño",
    labelSeverity:           "Gravedad del daño",
    labelContainment:        "Medidas de contención",
    labelStatus:             "Estado",
    none:                    "—",
    criteriaApplied:         "Criterios aplicados:",
    noCriteria:              "Ningún criterio de notificación aplica.",
    sectionBasic:            "Información básica",
    sectionIncident:         "Detalles del incidente",
    sectionData:             "Datos afectados",
    sectionRisk:             "Evaluación de riesgo",
    sectionResponse:         "Respuesta",
    sectionNotif:            "Notificaciones (Art. 33–34)",
    fieldName:               "Nombre del incidente",
    placeholderName:         "Ataque de ransomware — julio 2025",
    labelName:               "Nombre del incidente",
    exportSelected:          "Exportar seleccionadas",
    exportAll:               "Exportar todas",
    selectedCount:           "seleccionadas",
    clearSelection:          "Limpiar selección",
    colIncident:             "Incidente",
  },
  en: {
    title:                   "GDPR Breach Register",
    back:                    "All tools",
    newBreach:               "New breach +",
    noBreach:                "No breaches on record",
    noBreachSub:             "Log your first incident to track notification obligations.",
    firstBreach:             "Log first breach →",
    formTitleNew:            "New breach",
    formTitleEdit:           "Edit breach",
    save:                    "Save",
    cancel:                  "Cancel",
    fieldCompany:            "Company",
    fieldIncidentDate:       "Incident date",
    fieldDetectionDate:      "Detection date",
    fieldDescription:        "Incident description",
    fieldDataCats:           "Affected data categories",
    fieldAffectedSubjects:   "Estimated affected subjects",
    fieldAffectedCountries:  "Affected countries (comma-separated)",
    fieldIncidentType:       "Incident type",
    fieldCause:              "Cause",
    fieldLikelihood:         "Likelihood of harm to data subjects",
    fieldSeverity:           "Severity of potential harm",
    fieldContainment:        "Containment measures applied",
    fieldStatus:             "Incident status",
    fieldNotif72hSentAt:     "Authority notification date (Art. 33)",
    fieldNotif72hNotes:      "Notes — authority notification",
    fieldNotifSubjectsSentAt:"Data subject communication date (Art. 34)",
    fieldNotifSubjectsNotes: "Notes — data subject communication",
    typeConfidentiality:     "Confidentiality",
    typeIntegrity:           "Integrity",
    typeAvailability:        "Availability",
    typeMultiple:            "Multiple",
    low:                     "Low",
    medium:                  "Medium",
    high:                    "High",
    statusOpen:              "Open",
    statusInvestigating:     "Investigating",
    statusContained:         "Contained",
    statusClosed:            "Closed",
    colCompany:              "Company",
    colDate:                 "Incident date",
    colType:                 "Type",
    colStatus:               "Status",
    colNotif72h:             "72h notif.",
    btnView:                 "View",
    btnEdit:                 "Edit",
    btnDelete:               "Delete",
    btnExport:               "Export",
    btnImport:               "Import JSON",
    detailTitle:             "Breach detail",
    backToList:              "← Back to list",
    notifSection:            "Notifiability assessment",
    notif72hTitle:           "Notification to supervisory authority",
    notifSubjectsTitle:      "Communication to data subjects",
    required:                "REQUIRED",
    notRequired:             "NOT REQUIRED",
    art33:                   "Art. 33 GDPR",
    art34:                   "Art. 34 GDPR",
    deadline72h:             "Deadline (72h from detection):",
    notSent:                 "Not recorded",
    criteriaLikelihood:      "Likelihood of harm is not low",
    criteriaSeverity:        "Severity of harm is not low",
    criteriaSensitiveData:   "Contains sensitive data categories",
    criteriaHighRisk:        "High likelihood and high severity",
    validationRequired:      "Incident name, company, incident date, detection date and description are required.",
    confirmDelete:           "Delete this breach? This action cannot be undone.",
    importError:             "Import error: file does not have the expected format or does not belong to this collection.",
    saveNotif:               "Save notification notes",
    notifSavedOk:            "Saved.",
    notifInfoTitle:          "Notification records",
    incidentInfo:            "Incident details",
    riskInfo:                "Risk assessment",
    responseInfo:            "Incident response",
    labelCompany:            "Company",
    labelIncidentDate:       "Incident date",
    labelDetectionDate:      "Detection date",
    labelDescription:        "Description",
    labelCause:              "Cause",
    labelIncidentType:       "Incident type",
    labelDataCats:           "Data categories",
    labelAffectedSubjects:   "Estimated affected subjects",
    labelAffectedCountries:  "Affected countries",
    labelLikelihood:         "Likelihood of harm",
    labelSeverity:           "Severity of harm",
    labelContainment:        "Containment measures",
    labelStatus:             "Status",
    none:                    "—",
    criteriaApplied:         "Criteria applied:",
    noCriteria:              "No notification criteria apply.",
    sectionBasic:            "Basic information",
    sectionIncident:         "Incident details",
    sectionData:             "Affected data",
    sectionRisk:             "Risk assessment",
    sectionResponse:         "Response",
    sectionNotif:            "Notifications (Art. 33–34)",
    fieldName:               "Incident name",
    placeholderName:         "Ransomware attack — July 2025",
    labelName:               "Incident name",
    exportSelected:          "Export selected",
    exportAll:               "Export all",
    selectedCount:           "selected",
    clearSelection:          "Clear selection",
    colIncident:             "Incident",
  },
};

// ─── DATA CATEGORIES ─────────────────────────────────────────────────────────
const DATA_CATEGORIES = [
  { key: "identification", es: "Datos de identificación",     en: "Identification data"   },
  { key: "contact",        es: "Datos de contacto",           en: "Contact data"           },
  { key: "financial",      es: "Datos financieros",           en: "Financial data"         },
  { key: "health",         es: "Datos de salud",              en: "Health data"            },
  { key: "biometric",      es: "Datos biométricos",           en: "Biometric data"         },
  { key: "location",       es: "Datos de localización",       en: "Location data"          },
  { key: "children",       es: "Datos de menores",            en: "Children's data"        },
  { key: "criminal",       es: "Datos penales",               en: "Criminal data"          },
  { key: "credentials",    es: "Contraseñas/credenciales",    en: "Passwords/credentials"  },
  { key: "other",          es: "Otros",                       en: "Other"                  },
];

// Keys that trigger notif72h / notifSubjects requirements
const SENSITIVE_72H      = new Set(["health","biometric","children","criminal","credentials"]);
const SENSITIVE_SUBJECTS = new Set(["health","biometric","children","criminal"]);

// ─── EMPTY FORM ───────────────────────────────────────────────────────────────
const EMPTY_FORM = {
  name:                 "",
  company:              "",
  incidentDate:         "",
  detectionDate:        "",
  description:          "",
  dataCategories:       [],
  affectedSubjects:     "",    // string in form, number in storage
  affectedCountries:    "",    // string in form (comma-sep), array in storage
  incidentType:         [],
  cause:                "",
  likelihood:           "medium",
  severity:             "medium",
  containmentMeasures:  "",
  status:               "open",
  notif72h:             { required: null, sentAt: "", notes: "" },
  notifSubjects:        { required: null, sentAt: "", notes: "" },
};

// ─── HELPERS ──────────────────────────────────────────────────────────────────
function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}

function toSlug(str) {
  return (str || "")
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60) || "breach";
}

function computeNotifiability(breach) {
  const cats             = breach.dataCategories || [];
  const hasSensitive72h  = cats.some(k => SENSITIVE_72H.has(k));
  const hasSensitiveSub  = cats.some(k => SENSITIVE_SUBJECTS.has(k));

  const notif72hRequired =
    breach.likelihood !== "low" || breach.severity !== "low" || hasSensitive72h;

  const notifSubjectsRequired =
    (breach.likelihood === "high" && breach.severity === "high") || hasSensitiveSub;

  const criteria72h = [];
  if (breach.likelihood !== "low")  criteria72h.push("likelihood");
  if (breach.severity   !== "low")  criteria72h.push("severity");
  if (hasSensitive72h)              criteria72h.push("sensitiveData");

  const criteriaSubjects = [];
  if (breach.likelihood === "high" && breach.severity === "high") criteriaSubjects.push("highRisk");
  if (hasSensitiveSub) criteriaSubjects.push("sensitiveData");

  return { notif72hRequired, notifSubjectsRequired, criteria72h, criteriaSubjects };
}

function get72hDeadline(detectionDate) {
  if (!detectionDate) return null;
  const d = new Date(detectionDate + "T00:00:00");
  if (isNaN(d.getTime())) return null;
  d.setHours(d.getHours() + 72);
  return d;
}

function formatDeadlineDT(date, lang) {
  if (!date) return "—";
  const locale = lang === "es" ? "es-ES" : "en-GB";
  return (
    date.toLocaleDateString(locale, { weekday:"short", day:"numeric", month:"short", year:"numeric" }) +
    " · " +
    date.toLocaleTimeString(locale, { hour:"2-digit", minute:"2-digit" })
  );
}

function incidentTypeLabel(type, t) {
  const map = {
    confidentiality: t.typeConfidentiality,
    integrity:       t.typeIntegrity,
    availability:    t.typeAvailability,
    multiple:        t.typeMultiple, // legacy
  };
  if (Array.isArray(type)) {
    if (type.length === 0) return "—";
    return type.map(k => map[k] || k).join(" + ");
  }
  return map[type] || type || "—";
}

function statusLabel(status, t) {
  const map = {
    open:          t.statusOpen,
    investigating: t.statusInvestigating,
    contained:     t.statusContained,
    closed:        t.statusClosed,
  };
  return map[status] || status;
}

function statusStyle(status) {
  const s = {
    open:          { bg: "#fff0f0", color: "#b00020" },
    investigating: { bg: "#fffbeb", color: "#b07a00" },
    contained:     { bg: "#eff6ff", color: "#1d4ed8" },
    closed:        { bg: "#f0fdf4", color: "#1a5c3a" },
  };
  return s[status] || { bg: "#f3f4f6", color: "#6b7280" };
}

function likelihoodStyle(value) {
  if (value === "low")    return { bg: "#f0fdf4", color: "#1a5c3a", border: "#86efac" };
  if (value === "medium") return { bg: "#fffbeb", color: "#b07a00", border: "#fcd34d" };
  if (value === "high")   return { bg: "#fff0f0", color: "#b00020", border: "#fca5a5" };
  return { bg: "#f3f4f6", color: "#6b7280", border: "#d1d5db" };
}

// ─── NAVBAR ───────────────────────────────────────────────────────────────────
function BRNavbar({ lang, onLangChange, onHome }) {
  return (
    <div style={{
      height: 52, background: TH.bg, borderBottom: `1px solid ${TH.border}`,
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "0 1.5rem", position: "sticky", top: 0, zIndex: 50,
      boxSizing: "border-box",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
        <div
          onClick={onHome}
          style={{ display:"flex", alignItems:"baseline", gap:"0.35rem", cursor:"pointer", userSelect:"none" }}
        >
          <span style={{ fontFamily:"'Syne',sans-serif", color: TH.navy, fontWeight: 800, fontSize:"1rem" }}>AT.</span>
          <span style={{ fontFamily:"'Syne',sans-serif", color: TH.accent, fontWeight: 400, fontSize:"0.9rem" }}>· tools</span>
        </div>
        <button onClick={onHome} style={{
          background: "none", border: "none", cursor: "pointer",
          fontFamily: "'DM Mono',monospace", fontSize: "0.68rem",
          color: TH.textMuted, letterSpacing: "0.04em", padding: 0,
        }}>
          ← {lang === "en" ? "All tools" : "Todas las herramientas"}
        </button>
      </div>
      <div style={{ display:"flex", border:`1px solid ${TH.border}`, borderRadius:6, overflow:"hidden" }}>
        {["es","en"].map(code => (
          <button key={code} onClick={() => onLangChange(code)} style={{
            background: lang === code ? TH.navy : "transparent",
            color:      lang === code ? "#ffffff" : TH.textMuted,
            border: "none", borderRadius: 0,
            padding: "0.3rem 0.75rem", cursor: "pointer",
            fontFamily: "'DM Mono',monospace", fontSize: "0.62rem",
            letterSpacing: "0.06em", transition: "all 0.15s",
          }}>
            {code === "es" ? "ESPAÑOL" : "ENGLISH"}
          </button>
        ))}
      </div>
    </div>
  );
}

// ─── SECTION LABEL ────────────────────────────────────────────────────────────
function SLabel({ text }) {
  return (
    <div style={{
      fontFamily: "'DM Mono',monospace", fontSize: "0.6rem", color: TH.accent,
      letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "1rem",
    }}>
      {text}
    </div>
  );
}

// ─── FIELD LABEL ─────────────────────────────────────────────────────────────
function FLabel({ children }) {
  return (
    <div style={{
      fontFamily: "'DM Mono',monospace", fontSize: "0.62rem", color: "#555f6e",
      letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "0.4rem",
    }}>
      {children}
    </div>
  );
}

// ─── NOTIF BLOCK (detail view helper) ────────────────────────────────────────
function NotifBlock({ title, art, isRequired, criteria, criteriaMap, deadline, deadlineLabel, sentAt, notes, lang, t }) {
  const rStyle = isRequired
    ? { bg: "#fff0f0", color: "#b00020" }
    : { bg: "#f0fdf4", color: "#1a5c3a" };

  return (
    <div style={{
      background: TH.surfaceWhite, border: `1px solid ${TH.border}`,
      borderRadius: 10, padding: "1.25rem", marginBottom: "1rem",
    }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"0.75rem", flexWrap:"wrap", gap:"0.5rem" }}>
        <div>
          <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:700, color: TH.text, fontSize:"0.95rem" }}>{title}</div>
          <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.6rem", color: TH.textMuted, letterSpacing:"0.1em", textTransform:"uppercase", marginTop:"0.2rem" }}>{art}</div>
        </div>
        <span style={{
          background: rStyle.bg, color: rStyle.color,
          fontFamily: "'DM Mono',monospace", fontSize: "0.65rem", fontWeight: 600,
          letterSpacing: "0.1em", padding: "0.3rem 0.75rem", borderRadius: 20,
        }}>
          {isRequired ? t.required : t.notRequired}
        </span>
      </div>

      {criteria.length > 0 && (
        <div style={{ marginBottom: "0.75rem" }}>
          <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.6rem", color: TH.textMuted, letterSpacing:"0.08em", textTransform:"uppercase", marginBottom:"0.4rem" }}>
            {t.criteriaApplied}
          </div>
          {criteria.map(c => (
            <div key={c} style={{ display:"flex", alignItems:"flex-start", gap:"0.4rem", marginBottom:"0.25rem" }}>
              <span style={{ color: rStyle.color, fontSize:"0.75rem", lineHeight:"1.4" }}>·</span>
              <span style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.8rem", color: TH.textSub, lineHeight:"1.4" }}>{criteriaMap[c]}</span>
            </div>
          ))}
        </div>
      )}

      {!isRequired && criteria.length === 0 && (
        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.8rem", color: TH.textMuted, marginBottom:"0.75rem" }}>
          {t.noCriteria}
        </div>
      )}

      {isRequired && deadline && (
        <div style={{ marginBottom: "0.75rem", padding:"0.6rem 0.9rem", background: "#fff0f0", borderRadius: 6, borderLeft: "3px solid #b00020" }}>
          <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.6rem", color:"#b00020", letterSpacing:"0.08em", textTransform:"uppercase", marginBottom:"0.2rem" }}>{deadlineLabel}</div>
          <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.82rem", color:"#b00020", fontWeight:500 }}>{formatDeadlineDT(deadline, lang)}</div>
        </div>
      )}

      <div>
        <FLabel>{sentAt ? sentAt : t.notSent}</FLabel>
        {notes && (
          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.82rem", color: TH.textSub, lineHeight:1.55 }}>{notes}</div>
        )}
        {!notes && !sentAt && (
          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.8rem", color: TH.textMuted }}>{t.notSent}</div>
        )}
      </div>
    </div>
  );
}

// ─── MODULE-LEVEL HELPER COMPONENTS ──────────────────────────────────────────
// Defined here (not inside BreachRegister) so React never recreates their type
// on re-render, which would cause inputs to lose focus.

function PageShell({ lang, onLangChange, onHome, children }) {
  return (
    <>
      <style>{BR_FONTS}</style>
      <div style={{ minHeight: "100vh", background: TH.bg, fontFamily: "'Syne',sans-serif" }}>
        <BRNavbar lang={lang} onLangChange={onLangChange} onHome={onHome} />
        {children}
      </div>
    </>
  );
}

function ToggleGroup({ value, options, onChange, colorFn }) {
  return (
    <div style={{ display:"flex", gap:"0.5rem", flexWrap:"wrap" }}>
      {options.map(o => {
        const sel = value === o.key;
        const cs  = colorFn ? colorFn(o.key) : { bg: TH.surfaceWhite, color: TH.textSub, border: TH.border };
        return (
          <button key={o.key} onClick={() => onChange(o.key)} style={{
            padding:"0.45rem 1rem",
            background: sel ? cs.bg    : TH.surfaceWhite,
            color:      sel ? cs.color : TH.textMuted,
            border:    `1px solid ${sel ? (cs.border || cs.color) : TH.border}`,
            borderLeft:`3px solid ${sel ? cs.color : "transparent"}`,
            borderRadius:6, cursor:"pointer",
            fontFamily:"'DM Mono',monospace", fontSize:"0.7rem",
            transition:"all 0.15s",
          }}>
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

function DetailField({ label, value, t }) {
  return (
    <div style={{ marginBottom:"0.85rem" }}>
      <FLabel>{label}</FLabel>
      <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.88rem", color: TH.textSub, lineHeight:1.55 }}>
        {value || <span style={{ color: TH.textMuted }}>{t.none}</span>}
      </div>
    </div>
  );
}

// ─── MAIN COMPONENT ──────────────────────────────────────────────────────────
export default function BreachRegister({ onHome, lang, onLangToggle }) {
  const [view, setView]                   = useState("list");
  const [breaches, setBreaches]           = useState([]);
  const [editingId, setEditingId]         = useState(null);
  const [detailId, setDetailId]           = useState(null);
  const [form, setForm]                   = useState(EMPTY_FORM);
  const [formError, setFormError]         = useState("");
  const [importError, setImportError]     = useState("");
  const [notif72hSentAt, setNotif72hSentAt]                 = useState("");
  const [notif72hNotes, setNotif72hNotes]                   = useState("");
  const [notifSubjectsSentAt, setNotifSubjectsSentAt]       = useState("");
  const [notifSubjectsNotes, setNotifSubjectsNotes]         = useState("");
  const [notifSaved, setNotifSaved]       = useState(false);
  const [selectedIds, setSelectedIds]     = useState([]);
  const importRef = useRef(null);
  const t = T[lang];

  // ── Storage helpers ────────────────────────────────────────────────────────
  const loadBreaches = useCallback(() => {
    const list   = storage.list(COLLECTIONS.BREACH_REGISTER);
    const loaded = list.map(({ id }) => {
      const entry = storage.load(COLLECTIONS.BREACH_REGISTER, id);
      if (!entry) return null;
      return { ...entry, _id: id };
    }).filter(Boolean);
    setBreaches(loaded);
  }, []);

  useEffect(() => { loadBreaches(); }, [loadBreaches]);

  const detailBreach = detailId ? (breaches.find(b => b._id === detailId) || null) : null;

  // ── Handlers ───────────────────────────────────────────────────────────────
  function handleNew() {
    setEditingId(null);
    setForm(EMPTY_FORM);
    setFormError("");
    setView("form");
  }

  function handleEdit(breach) {
    setEditingId(breach._id);
    setForm({
      name:                breach.name                || "",
      company:             breach.company             || "",
      incidentDate:        breach.incidentDate        || "",
      detectionDate:       breach.detectionDate       || "",
      description:         breach.description         || "",
      dataCategories:      breach.dataCategories      || [],
      affectedSubjects:    breach.affectedSubjects != null ? String(breach.affectedSubjects) : "",
      affectedCountries:   Array.isArray(breach.affectedCountries)
                             ? breach.affectedCountries.join(", ")
                             : (breach.affectedCountries || ""),
      incidentType:        Array.isArray(breach.incidentType) ? breach.incidentType : (breach.incidentType ? [breach.incidentType] : []),
      cause:               breach.cause               || "",
      likelihood:          breach.likelihood          || "medium",
      severity:            breach.severity            || "medium",
      containmentMeasures: breach.containmentMeasures || "",
      status:              breach.status              || "open",
      notif72h:            breach.notif72h            || { required: null, sentAt: "", notes: "" },
      notifSubjects:       breach.notifSubjects       || { required: null, sentAt: "", notes: "" },
    });
    setFormError("");
    setView("form");
  }

  function handleDetail(breach) {
    setDetailId(breach._id);
    setNotif72hSentAt(breach.notif72h?.sentAt        || "");
    setNotif72hNotes(breach.notif72h?.notes          || "");
    setNotifSubjectsSentAt(breach.notifSubjects?.sentAt || "");
    setNotifSubjectsNotes(breach.notifSubjects?.notes   || "");
    setNotifSaved(false);
    setView("detail");
  }

  function handleSave() {
    if (!form.name || !form.company || !form.incidentDate || !form.detectionDate || !form.description) {
      setFormError(t.validationRequired);
      return;
    }
    const id = editingId || generateId();
    const dataToSave = {
      ...form,
      affectedSubjects:  form.affectedSubjects ? (parseInt(form.affectedSubjects, 10) || 0) : 0,
      affectedCountries: form.affectedCountries
        ? form.affectedCountries.split(",").map(s => s.trim()).filter(Boolean)
        : [],
    };
    storage.save(COLLECTIONS.BREACH_REGISTER, id, dataToSave);
    loadBreaches();
    setEditingId(null);
    setForm(EMPTY_FORM);
    setFormError("");
    setView("list");
  }

  function handleDelete(id) {
    if (!window.confirm(t.confirmDelete)) return;
    storage.delete(COLLECTIONS.BREACH_REGISTER, id);
    setSelectedIds(prev => prev.filter(sid => sid !== id));
    loadBreaches();
  }

  async function handleImportFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const raw = await file.text();
      const parsed = JSON.parse(raw);
      if (parsed.exportType === "multiple") {
        if (!Array.isArray(parsed.items) || parsed.collection !== COLLECTIONS.BREACH_REGISTER) {
          setImportError(t.importError);
          e.target.value = "";
          return;
        }
        parsed.items.forEach(item => {
          if (item.id && item.data) {
            storage.save(COLLECTIONS.BREACH_REGISTER, item.id, item.data);
          }
        });
        loadBreaches();
        setImportError("");
      } else {
        if (
          typeof parsed !== "object" || parsed === null ||
          typeof parsed.collection !== "string" ||
          typeof parsed.id !== "string" ||
          typeof parsed.data !== "object" || parsed.data === null
        ) {
          setImportError(t.importError);
          e.target.value = "";
          return;
        }
        if (parsed.collection !== COLLECTIONS.BREACH_REGISTER) {
          setImportError(t.importError);
          e.target.value = "";
          return;
        }
        storage.save(COLLECTIONS.BREACH_REGISTER, parsed.id, parsed.data);
        loadBreaches();
        setImportError("");
      }
    } catch (err) {
      console.error("[BreachRegister] import error:", err);
      setImportError(t.importError);
    }
    e.target.value = "";
  }

  function handleExportSingle(b) {
    const { _meta, _id, ...data } = b;
    const payload = {
      exportType: "single",
      collection: COLLECTIONS.BREACH_REGISTER,
      id: _id,
      data,
      exportedAt: new Date().toISOString(),
    };
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
    const url  = URL.createObjectURL(blob);
    const slug = toSlug(b.name || b.company);
    const date = new Date().toISOString().slice(0, 10);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `breach-register-${slug}-${date}.json`;
    a.click();
    URL.revokeObjectURL(url);
  }

  function handleExportMultiple(items) {
    const date = new Date().toISOString();
    const payload = {
      exportType: "multiple",
      collection: COLLECTIONS.BREACH_REGISTER,
      items: items.map(b => {
        const { _meta, _id, ...data } = b;
        return { id: _id, data, exportedAt: date };
      }),
      exportedAt: date,
    };
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `breach-register-export-${date.slice(0, 10)}.json`;
    a.click();
    URL.revokeObjectURL(url);
  }

  function handleExportSelected() {
    const items = breaches.filter(b => selectedIds.includes(b._id));
    if (items.length === 0) return;
    handleExportMultiple(items);
  }

  function handleExportAll() {
    if (breaches.length === 0) return;
    handleExportMultiple(breaches);
  }

  function handleSaveNotifInfo() {
    if (!detailBreach) return;
    const id = detailBreach._id;
    storage.save(COLLECTIONS.BREACH_REGISTER, id, {
      name:                detailBreach.name,
      company:             detailBreach.company,
      incidentDate:        detailBreach.incidentDate,
      detectionDate:       detailBreach.detectionDate,
      description:         detailBreach.description,
      dataCategories:      detailBreach.dataCategories      || [],
      affectedSubjects:    detailBreach.affectedSubjects,
      affectedCountries:   detailBreach.affectedCountries   || [],
      incidentType:        detailBreach.incidentType,
      cause:               detailBreach.cause,
      likelihood:          detailBreach.likelihood,
      severity:            detailBreach.severity,
      containmentMeasures: detailBreach.containmentMeasures,
      status:              detailBreach.status,
      notif72h:      { ...(detailBreach.notif72h      || {}), sentAt: notif72hSentAt,       notes: notif72hNotes       },
      notifSubjects: { ...(detailBreach.notifSubjects || {}), sentAt: notifSubjectsSentAt,  notes: notifSubjectsNotes  },
    });
    loadBreaches();
    setNotifSaved(true);
    setTimeout(() => setNotifSaved(false), 2500);
  }

  // ── Shared button styles ───────────────────────────────────────────────────
  const btnPrimary = {
    background: TH.navy, color: "#fff", border: "none", borderRadius: 6,
    padding: "0.65rem 1.5rem", fontFamily: "'Syne',sans-serif", fontWeight: 700,
    fontSize: "0.88rem", cursor: "pointer", letterSpacing: "0.03em",
  };
  const btnSecondary = {
    background: "transparent", color: TH.textMuted, border: `1px solid ${TH.border}`,
    borderRadius: 6, padding: "0.65rem 1.25rem", fontFamily: "'Syne',sans-serif",
    fontWeight: 600, fontSize: "0.88rem", cursor: "pointer",
  };
  const btnSmall = {
    background: "transparent", color: TH.textMuted, border: `1px solid ${TH.border}`,
    borderRadius: 5, padding: "0.3rem 0.65rem", fontFamily: "'DM Mono',monospace",
    fontSize: "0.65rem", cursor: "pointer",
  };
  const btnSmallAccent = { ...btnSmall, color: TH.accent, borderColor: "#b8dfc8" };
  const btnSmallDanger = { ...btnSmall, color: "#b00020", borderColor: "#fca5a5" };

  // ══════════════════════════════════════════════════════════════════════════
  // VIEW: LIST
  // ══════════════════════════════════════════════════════════════════════════
  if (view === "list") {
    return (
      <PageShell lang={lang} onLangChange={onLangToggle} onHome={onHome}>
        <div style={{ maxWidth: 900, margin: "0 auto", padding: "3rem 1.5rem 4rem" }}>
          {/* Header */}
          <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:"2rem", flexWrap:"wrap", gap:"1rem" }}>
            <div>
              <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.6rem", color: TH.accent, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:"0.5rem" }}>
                RGPD · Art. 33
              </div>
              <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:"clamp(1.3rem,3vw,1.7rem)", fontWeight:800, color: TH.navy, margin:0 }}>
                {t.title}
              </h1>
            </div>
            <div style={{ display:"flex", gap:"0.75rem", flexWrap:"wrap", alignItems:"center" }}>
              <input
                ref={importRef} type="file" accept=".json"
                style={{ display:"none" }} onChange={handleImportFile}
              />
              <button style={btnSecondary} onClick={() => importRef.current && importRef.current.click()}>
                {t.btnImport}
              </button>
              <button style={btnPrimary} onClick={handleNew}>{t.newBreach}</button>
            </div>
          </div>

          {importError && (
            <div style={{ background:"#fff0f0", border:"1px solid #fca5a5", borderRadius:8, padding:"0.75rem 1rem", color:"#b00020", fontFamily:"'Syne',sans-serif", fontSize:"0.82rem", marginBottom:"1.5rem" }}>
              {importError}
            </div>
          )}

          {/* Empty state */}
          {breaches.length === 0 && (
            <div style={{ textAlign:"center", padding:"5rem 2rem", background: TH.surfaceWhite, borderRadius:12, border:`1px solid ${TH.border}` }}>
              <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.6rem", color: TH.textMuted, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:"1rem" }}>
                {t.noBreach}
              </div>
              <p style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.9rem", color: TH.textMuted, maxWidth:380, margin:"0 auto 2rem", lineHeight:1.65 }}>
                {t.noBreachSub}
              </p>
              <button style={btnPrimary} onClick={handleNew}>{t.firstBreach}</button>
            </div>
          )}

          {/* Breach cards */}
          {breaches.length > 0 && (
            <div style={{ display:"flex", flexDirection:"column", gap:"0.75rem" }}>
              {/* Selection action bar */}
              {selectedIds.length > 0 && (
                <div style={{ display:"flex", alignItems:"center", gap:"1rem", padding:"0.65rem 1rem", background:"#f0fdf4", border:`1px solid #86efac`, borderRadius:8, flexWrap:"wrap" }}>
                  <span style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.68rem", color: TH.accent, fontWeight:500 }}>
                    {selectedIds.length} {t.selectedCount}
                  </span>
                  <button style={btnSmallAccent} onClick={handleExportSelected}>{t.exportSelected}</button>
                  <button style={btnSmall}       onClick={handleExportAll}>{t.exportAll}</button>
                  <button style={{ ...btnSmall, marginLeft:"auto" }} onClick={() => setSelectedIds([])}>{t.clearSelection}</button>
                </div>
              )}

              {/* Column headers */}
              <div style={{ display:"grid", gridTemplateColumns:"28px 1fr 110px 110px 120px 140px", gap:"0.5rem 1rem", padding:"0 1rem", alignItems:"center" }}>
                <div>
                  <input
                    type="checkbox"
                    checked={selectedIds.length === breaches.length && breaches.length > 0}
                    onChange={e => setSelectedIds(e.target.checked ? breaches.map(b => b._id) : [])}
                    style={{ accentColor: TH.accent, cursor:"pointer" }}
                  />
                </div>
                {[t.colIncident, t.colDate, t.colType, t.colStatus, t.colNotif72h].map(h => (
                  <div key={h} style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.58rem", color: TH.textMuted, letterSpacing:"0.1em", textTransform:"uppercase" }}>{h}</div>
                ))}
              </div>

              {breaches.map(b => {
                const ss  = statusStyle(b.status);
                const canComputeNotif = b.likelihood && b.severity;
                const { notif72hRequired } = canComputeNotif
                  ? computeNotifiability(b)
                  : { notif72hRequired: null };
                const notifBadge =
                  notif72hRequired === null  ? { bg:"#f3f4f6", color:"#6b7280", label:"?" } :
                  notif72hRequired           ? { bg:"#fff0f0",  color:"#b00020", label: t.required } :
                                               { bg:"#f0fdf4",  color:"#1a5c3a", label: t.notRequired };
                const isSelected = selectedIds.includes(b._id);

                return (
                  <div key={b._id} style={{
                    background: isSelected ? "#f0fdf4" : TH.surfaceWhite,
                    border: `1px solid ${isSelected ? "#86efac" : TH.border}`,
                    borderRadius:10, padding:"1rem 1.25rem",
                    transition: "background 0.12s, border-color 0.12s",
                  }}>
                    <div style={{ display:"grid", gridTemplateColumns:"28px 1fr 110px 110px 120px 140px", gap:"0.5rem 1rem", alignItems:"center" }}>
                      {/* Checkbox */}
                      <div>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={e => setSelectedIds(prev =>
                            e.target.checked ? [...prev, b._id] : prev.filter(id => id !== b._id)
                          )}
                          style={{ accentColor: TH.accent, cursor:"pointer" }}
                        />
                      </div>
                      {/* Incident name + company */}
                      <div style={{ overflow:"hidden" }}>
                        <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:600, color: TH.text, fontSize:"0.82rem", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                          {b.name || b.company || "—"}
                        </div>
                        {b.name && (
                          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.75rem", color: TH.textMuted, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", marginTop:"0.1rem" }}>
                            {b.company}
                          </div>
                        )}
                      </div>
                      {/* Date */}
                      <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.72rem", color: TH.textSub }}>{b.incidentDate || "—"}</div>
                      {/* Type */}
                      <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.68rem", color: TH.textMuted }}>{incidentTypeLabel(b.incidentType, t)}</div>
                      {/* Status */}
                      <div>
                        <span style={{ background: ss.bg, color: ss.color, borderRadius:20, padding:"0.2rem 0.6rem", fontFamily:"'DM Mono',monospace", fontSize:"0.62rem", fontWeight:500 }}>
                          {statusLabel(b.status, t)}
                        </span>
                      </div>
                      {/* Notif 72h */}
                      <div>
                        <span style={{ background: notifBadge.bg, color: notifBadge.color, borderRadius:20, padding:"0.2rem 0.6rem", fontFamily:"'DM Mono',monospace", fontSize:"0.6rem", fontWeight:500 }}>
                          {notifBadge.label}
                        </span>
                      </div>
                    </div>

                    {/* Actions */}
                    <div style={{ display:"flex", gap:"0.5rem", marginTop:"0.85rem", paddingTop:"0.85rem", borderTop:`1px solid ${TH.border}40`, flexWrap:"wrap" }}>
                      <button style={btnSmallAccent} onClick={() => handleDetail(b)}>{t.btnView}</button>
                      <button style={btnSmall}       onClick={() => handleEdit(b)}>{t.btnEdit}</button>
                      <button style={btnSmallDanger} onClick={() => handleDelete(b._id)}>{t.btnDelete}</button>
                      <button style={btnSmall}       onClick={() => handleExportSingle(b)}>{t.btnExport}</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </PageShell>
    );
  }

  // ══════════════════════════════════════════════════════════════════════════
  // VIEW: FORM
  // ══════════════════════════════════════════════════════════════════════════
  if (view === "form") {
    const F = form; // alias for brevity
    const setF = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

    const incidentTypeOptions = [
      { key:"confidentiality", label: t.typeConfidentiality },
      { key:"integrity",       label: t.typeIntegrity       },
      { key:"availability",    label: t.typeAvailability    },
    ];
    const riskLevels = [
      { key:"low",    label: t.low    },
      { key:"medium", label: t.medium },
      { key:"high",   label: t.high   },
    ];
    const statuses = [
      { key:"open",          label: t.statusOpen          },
      { key:"investigating", label: t.statusInvestigating },
      { key:"contained",     label: t.statusContained     },
      { key:"closed",        label: t.statusClosed        },
    ];

    return (
      <PageShell lang={lang} onLangChange={onLangToggle} onHome={onHome}>
        <div style={{ maxWidth:760, margin:"0 auto", padding:"3rem 1.5rem 5rem" }}>
          <div style={{ marginBottom:"2rem" }}>
            <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:"1.5rem", fontWeight:800, color: TH.navy, margin:"0 0 0.25rem" }}>
              {editingId ? t.formTitleEdit : t.formTitleNew}
            </h1>
          </div>

          {formError && (
            <div style={{ background:"#fff0f0", border:"1px solid #fca5a5", borderRadius:8, padding:"0.75rem 1rem", color:"#b00020", fontFamily:"'Syne',sans-serif", fontSize:"0.82rem", marginBottom:"1.5rem" }}>
              {formError}
            </div>
          )}

          <div style={{ display:"flex", flexDirection:"column", gap:"2rem" }}>
            {/* ── Basic info ── */}
            <section style={{ background: TH.surfaceWhite, border:`1px solid ${TH.border}`, borderRadius:10, padding:"1.5rem" }}>
              <SLabel text={t.sectionBasic} />
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"1rem" }}>
                <div style={{ gridColumn:"1/-1" }}>
                  <FLabel>{t.fieldName}</FLabel>
                  <input style={INPUT_STYLE} value={F.name} placeholder={t.placeholderName} maxLength={80} onChange={e => setF("name", e.target.value)} />
                </div>
                <div style={{ gridColumn:"1/-1" }}>
                  <FLabel>{t.fieldCompany}</FLabel>
                  <input style={INPUT_STYLE} value={F.company} placeholder="Acme Corp" onChange={e => setF("company", e.target.value)} />
                </div>
                <div>
                  <FLabel>{t.fieldIncidentDate}</FLabel>
                  <input style={INPUT_STYLE} type="date" value={F.incidentDate} onChange={e => setF("incidentDate", e.target.value)} />
                </div>
                <div>
                  <FLabel>{t.fieldDetectionDate}</FLabel>
                  <input style={INPUT_STYLE} type="date" value={F.detectionDate} onChange={e => setF("detectionDate", e.target.value)} />
                </div>
                <div style={{ gridColumn:"1/-1" }}>
                  <FLabel>{t.fieldStatus}</FLabel>
                  <select style={INPUT_STYLE} value={F.status} onChange={e => setF("status", e.target.value)}>
                    {statuses.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
                  </select>
                </div>
              </div>
            </section>

            {/* ── Incident details ── */}
            <section style={{ background: TH.surfaceWhite, border:`1px solid ${TH.border}`, borderRadius:10, padding:"1.5rem" }}>
              <SLabel text={t.sectionIncident} />
              <div style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
                <div>
                  <FLabel>{t.fieldIncidentType}</FLabel>
                  <div style={{ display:"flex", gap:"0.5rem", flexWrap:"wrap" }}>
                    {incidentTypeOptions.map(o => {
                      const sel = F.incidentType.includes(o.key);
                      return (
                        <button key={o.key} onClick={() => setForm(prev => ({ ...prev, incidentType: prev.incidentType.includes(o.key) ? prev.incidentType.filter(k => k !== o.key) : [...prev.incidentType, o.key] }))} style={{
                          padding:"0.45rem 1rem",
                          background: sel ? "#f0fdf4" : TH.surfaceWhite,
                          color:      sel ? TH.accent  : TH.textMuted,
                          border:    `1px solid ${sel ? "#86efac" : TH.border}`,
                          borderLeft: sel ? `3px solid ${TH.accent}` : `1px solid ${TH.border}`,
                          borderRadius:6, cursor:"pointer",
                          fontFamily:"'DM Mono',monospace", fontSize:"0.7rem",
                          transition:"all 0.15s",
                        }}>
                          {o.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div>
                  <FLabel>{t.fieldDescription}</FLabel>
                  <textarea style={TEXTAREA_STYLE} value={F.description} onChange={e => setF("description", e.target.value)} />
                </div>
                <div>
                  <FLabel>{t.fieldCause}</FLabel>
                  <textarea style={{ ...TEXTAREA_STYLE, minHeight:"3.5rem" }} value={F.cause} onChange={e => setF("cause", e.target.value)} />
                </div>
              </div>
            </section>

            {/* ── Affected data ── */}
            <section style={{ background: TH.surfaceWhite, border:`1px solid ${TH.border}`, borderRadius:10, padding:"1.5rem" }}>
              <SLabel text={t.sectionData} />
              <div style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
                <div>
                  <FLabel>{t.fieldDataCats}</FLabel>
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))", gap:"0.4rem" }}>
                    {DATA_CATEGORIES.map(cat => {
                      const checked = F.dataCategories.includes(cat.key);
                      return (
                        <label key={cat.key} style={{ display:"flex", alignItems:"center", gap:"0.5rem", cursor:"pointer", padding:"0.35rem 0.5rem", borderRadius:5, background: checked ? "#f0fdf4" : "transparent" }}>
                          <input
                            type="checkbox" checked={checked}
                            onChange={ev => {
                              if (ev.target.checked) {
                                setF("dataCategories", [...F.dataCategories, cat.key]);
                              } else {
                                setF("dataCategories", F.dataCategories.filter(k => k !== cat.key));
                              }
                            }}
                            style={{ accentColor: TH.accent }}
                          />
                          <span style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.82rem", color: checked ? TH.accent : TH.textSub }}>{cat[lang]}</span>
                        </label>
                      );
                    })}
                  </div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"1rem" }}>
                  <div>
                    <FLabel>{t.fieldAffectedSubjects}</FLabel>
                    <input style={INPUT_STYLE} type="number" min="0" value={F.affectedSubjects} onChange={e => setF("affectedSubjects", e.target.value)} />
                  </div>
                  <div>
                    <FLabel>{t.fieldAffectedCountries}</FLabel>
                    <input style={INPUT_STYLE} value={F.affectedCountries} onChange={e => setF("affectedCountries", e.target.value)} />
                  </div>
                </div>
              </div>
            </section>

            {/* ── Risk assessment ── */}
            <section style={{ background: TH.surfaceWhite, border:`1px solid ${TH.border}`, borderRadius:10, padding:"1.5rem" }}>
              <SLabel text={t.sectionRisk} />
              <div style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
                <div>
                  <FLabel>{t.fieldLikelihood}</FLabel>
                  <ToggleGroup value={F.likelihood} options={riskLevels} onChange={v => setF("likelihood", v)} colorFn={likelihoodStyle} />
                </div>
                <div>
                  <FLabel>{t.fieldSeverity}</FLabel>
                  <ToggleGroup value={F.severity} options={riskLevels} onChange={v => setF("severity", v)} colorFn={likelihoodStyle} />
                </div>
              </div>
            </section>

            {/* ── Response ── */}
            <section style={{ background: TH.surfaceWhite, border:`1px solid ${TH.border}`, borderRadius:10, padding:"1.5rem" }}>
              <SLabel text={t.sectionResponse} />
              <div>
                <FLabel>{t.fieldContainment}</FLabel>
                <textarea style={TEXTAREA_STYLE} value={F.containmentMeasures} onChange={e => setF("containmentMeasures", e.target.value)} />
              </div>
            </section>

            {/* ── Notification records ── */}
            <section style={{ background: TH.surfaceWhite, border:`1px solid ${TH.border}`, borderRadius:10, padding:"1.5rem" }}>
              <SLabel text={t.sectionNotif} />
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"1rem" }}>
                <div>
                  <FLabel>{t.fieldNotif72hSentAt}</FLabel>
                  <input style={INPUT_STYLE} type="date"
                    value={F.notif72h?.sentAt || ""}
                    onChange={e => setForm(prev => ({ ...prev, notif72h: { ...(prev.notif72h||{}), sentAt: e.target.value } }))}
                  />
                </div>
                <div>
                  <FLabel>{t.fieldNotifSubjectsSentAt}</FLabel>
                  <input style={INPUT_STYLE} type="date"
                    value={F.notifSubjects?.sentAt || ""}
                    onChange={e => setForm(prev => ({ ...prev, notifSubjects: { ...(prev.notifSubjects||{}), sentAt: e.target.value } }))}
                  />
                </div>
                <div>
                  <FLabel>{t.fieldNotif72hNotes}</FLabel>
                  <textarea style={{ ...TEXTAREA_STYLE, minHeight:"3rem" }}
                    value={F.notif72h?.notes || ""}
                    onChange={e => setForm(prev => ({ ...prev, notif72h: { ...(prev.notif72h||{}), notes: e.target.value } }))}
                  />
                </div>
                <div>
                  <FLabel>{t.fieldNotifSubjectsNotes}</FLabel>
                  <textarea style={{ ...TEXTAREA_STYLE, minHeight:"3rem" }}
                    value={F.notifSubjects?.notes || ""}
                    onChange={e => setForm(prev => ({ ...prev, notifSubjects: { ...(prev.notifSubjects||{}), notes: e.target.value } }))}
                  />
                </div>
              </div>
            </section>

            {/* Actions */}
            <div style={{ display:"flex", gap:"0.75rem", position:"sticky", bottom:0, background:"#ffffff", borderTop:"1px solid #d6d2ca", padding:"1rem 0", marginTop:"1rem", zIndex:5 }}>
              <button style={btnPrimary} onClick={handleSave}>{t.save}</button>
              <button style={btnSecondary} onClick={() => { setView("list"); setEditingId(null); setForm(EMPTY_FORM); setFormError(""); }}>{t.cancel}</button>
            </div>
          </div>
        </div>
      </PageShell>
    );
  }

  // ══════════════════════════════════════════════════════════════════════════
  // VIEW: DETAIL
  // ══════════════════════════════════════════════════════════════════════════
  if (view === "detail") {
    if (!detailBreach) {
      return (
        <PageShell lang={lang} onLangChange={onLangToggle} onHome={onHome}>
          <div style={{ maxWidth:760, margin:"0 auto", padding:"3rem 1.5rem" }}>
            <button style={btnSecondary} onClick={() => setView("list")}>{t.backToList}</button>
          </div>
        </PageShell>
      );
    }

    const b = detailBreach;
    const ss  = statusStyle(b.status);
    const { notif72hRequired, notifSubjectsRequired, criteria72h, criteriaSubjects } =
      computeNotifiability(b);
    const deadline = get72hDeadline(b.detectionDate);

    const criteriaMap = {
      likelihood:   t.criteriaLikelihood,
      severity:     t.criteriaSeverity,
      sensitiveData: t.criteriaSensitiveData,
      highRisk:     t.criteriaHighRisk,
    };

    const cats = (b.dataCategories || []).map(k => DATA_CATEGORIES.find(c => c.key === k)?.[lang] || k);
    const countries = Array.isArray(b.affectedCountries) ? b.affectedCountries : [];

    return (
      <PageShell lang={lang} onLangChange={onLangToggle} onHome={onHome}>
        <div style={{ maxWidth:800, margin:"0 auto", padding:"3rem 1.5rem 5rem" }}>
          {/* Header */}
          <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:"2rem", flexWrap:"wrap", gap:"1rem" }}>
            <div>
              <button style={{ ...btnSecondary, padding:"0.4rem 0.9rem", fontSize:"0.72rem", marginBottom:"0.75rem" }} onClick={() => setView("list")}>
                {t.backToList}
              </button>
              <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:"1.5rem", fontWeight:800, color: TH.navy, margin:"0 0 0.4rem" }}>
                {b.name || b.company || t.detailTitle}
              </h1>
              <span style={{ background: ss.bg, color: ss.color, borderRadius:20, padding:"0.25rem 0.75rem", fontFamily:"'DM Mono',monospace", fontSize:"0.65rem", fontWeight:500 }}>
                {statusLabel(b.status, t)}
              </span>
            </div>
            <div style={{ display:"flex", gap:"0.5rem" }}>
              <button style={btnSmall} onClick={() => handleEdit(b)}>{t.btnEdit}</button>
              <button style={btnSmall} onClick={() => storage.exportJSON(COLLECTIONS.BREACH_REGISTER, b._id)}>{t.btnExport}</button>
            </div>
          </div>

          <div style={{ display:"flex", flexDirection:"column", gap:"1.5rem" }}>
            {/* Incident info */}
            <section style={{ background: TH.surfaceWhite, border:`1px solid ${TH.border}`, borderRadius:10, padding:"1.5rem" }}>
              <SLabel text={t.incidentInfo} />
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 2rem" }}>
                {b.name && (
                  <div style={{ gridColumn:"1/-1" }}>
                    <DetailField t={t} label={t.labelName} value={b.name} />
                  </div>
                )}
                <DetailField t={t} label={t.labelIncidentDate}  value={b.incidentDate} />
                <DetailField t={t} label={t.labelDetectionDate} value={b.detectionDate} />
                <DetailField t={t} label={t.labelIncidentType}  value={incidentTypeLabel(b.incidentType, t)} />
                <DetailField t={t} label={t.labelAffectedSubjects} value={b.affectedSubjects ? String(b.affectedSubjects) : null} />
                <div style={{ gridColumn:"1/-1" }}>
                  <DetailField t={t} label={t.labelDescription} value={b.description} />
                </div>
                <div style={{ gridColumn:"1/-1" }}>
                  <DetailField t={t} label={t.labelCause} value={b.cause} />
                </div>
                <div style={{ gridColumn:"1/-1" }}>
                  <FLabel>{t.labelDataCats}</FLabel>
                  {cats.length > 0 ? (
                    <div style={{ display:"flex", flexWrap:"wrap", gap:"0.4rem" }}>
                      {cats.map((c, i) => (
                        <span key={i} style={{ background:"#f0fdf4", color: TH.accent, borderRadius:20, padding:"0.2rem 0.65rem", fontFamily:"'DM Mono',monospace", fontSize:"0.68rem" }}>{c}</span>
                      ))}
                    </div>
                  ) : (
                    <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.88rem", color: TH.textMuted }}>{t.none}</div>
                  )}
                </div>
                {countries.length > 0 && (
                  <div style={{ gridColumn:"1/-1", marginTop:"0.85rem" }}>
                    <DetailField t={t} label={t.labelAffectedCountries} value={countries.join(", ")} />
                  </div>
                )}
              </div>
            </section>

            {/* Risk + Response */}
            <section style={{ background: TH.surfaceWhite, border:`1px solid ${TH.border}`, borderRadius:10, padding:"1.5rem" }}>
              <SLabel text={t.riskInfo} />
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 2rem" }}>
                <div>
                  <FLabel>{t.labelLikelihood}</FLabel>
                  {b.likelihood ? (
                    <span style={{ ...(() => { const s = likelihoodStyle(b.likelihood); return { background: s.bg, color: s.color }; })(), borderRadius:20, padding:"0.25rem 0.75rem", fontFamily:"'DM Mono',monospace", fontSize:"0.68rem", fontWeight:500 }}>
                      {t[b.likelihood] || b.likelihood}
                    </span>
                  ) : <span style={{ color: TH.textMuted, fontFamily:"'Syne',sans-serif", fontSize:"0.88rem" }}>{t.none}</span>}
                </div>
                <div>
                  <FLabel>{t.labelSeverity}</FLabel>
                  {b.severity ? (
                    <span style={{ ...(() => { const s = likelihoodStyle(b.severity); return { background: s.bg, color: s.color }; })(), borderRadius:20, padding:"0.25rem 0.75rem", fontFamily:"'DM Mono',monospace", fontSize:"0.68rem", fontWeight:500 }}>
                      {t[b.severity] || b.severity}
                    </span>
                  ) : <span style={{ color: TH.textMuted, fontFamily:"'Syne',sans-serif", fontSize:"0.88rem" }}>{t.none}</span>}
                </div>
              </div>
              {b.containmentMeasures && (
                <div style={{ marginTop:"1rem" }}>
                  <DetailField t={t} label={t.labelContainment} value={b.containmentMeasures} />
                </div>
              )}
            </section>

            {/* ── Notifiability assessment ─────────────────────────────────── */}
            <section>
              <SLabel text={t.notifSection} />
              <NotifBlock
                title={t.notif72hTitle}
                art={t.art33}
                isRequired={notif72hRequired}
                criteria={criteria72h}
                criteriaMap={criteriaMap}
                deadline={deadline}
                deadlineLabel={t.deadline72h}
                sentAt={b.notif72h?.sentAt || ""}
                notes={b.notif72h?.notes || ""}
                lang={lang}
                t={t}
              />
              <NotifBlock
                title={t.notifSubjectsTitle}
                art={t.art34}
                isRequired={notifSubjectsRequired}
                criteria={criteriaSubjects}
                criteriaMap={criteriaMap}
                deadline={null}
                deadlineLabel=""
                sentAt={b.notifSubjects?.sentAt || ""}
                notes={b.notifSubjects?.notes || ""}
                lang={lang}
                t={t}
              />
            </section>

            {/* ── Editable notification records ─────────────────────────────── */}
            <section style={{ background: TH.surfaceWhite, border:`1px solid ${TH.border}`, borderRadius:10, padding:"1.5rem" }}>
              <SLabel text={t.notifInfoTitle} />
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"1rem" }}>
                <div>
                  <FLabel>{t.fieldNotif72hSentAt}</FLabel>
                  <input style={INPUT_STYLE} type="date" value={notif72hSentAt} onChange={e => setNotif72hSentAt(e.target.value)} />
                </div>
                <div>
                  <FLabel>{t.fieldNotifSubjectsSentAt}</FLabel>
                  <input style={INPUT_STYLE} type="date" value={notifSubjectsSentAt} onChange={e => setNotifSubjectsSentAt(e.target.value)} />
                </div>
                <div>
                  <FLabel>{t.fieldNotif72hNotes}</FLabel>
                  <textarea style={{ ...TEXTAREA_STYLE, minHeight:"3rem" }} value={notif72hNotes} onChange={e => setNotif72hNotes(e.target.value)} />
                </div>
                <div>
                  <FLabel>{t.fieldNotifSubjectsNotes}</FLabel>
                  <textarea style={{ ...TEXTAREA_STYLE, minHeight:"3rem" }} value={notifSubjectsNotes} onChange={e => setNotifSubjectsNotes(e.target.value)} />
                </div>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:"1rem", marginTop:"1rem" }}>
                <button style={btnPrimary} onClick={handleSaveNotifInfo}>{t.saveNotif}</button>
                {notifSaved && (
                  <span style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.72rem", color: TH.accent }}>{t.notifSavedOk}</span>
                )}
              </div>
            </section>
          </div>
        </div>
      </PageShell>
    );
  }

  return null;
}
